import React from 'react';
import PropTypes from 'prop-types';

import CommentField from './CommentField';

import utils from './utils';

import { toast } from '../toast';

class ReplyEdit extends React.Component {
    componentDidMount () {
        this.editField.setContent(this.props.reply.content);
        this.editField.setFocus();
    };

    exitEditing = () =>
        this.props.expandedComponent.setReplyEditing(false);

    updateReply = () => {
        if (this.editField.isEmpty ||
            this.editField.isProcessing() ||
            this.editField.hasError()
        ) {
            return Promise.reject();
        }

        const updatedReply = {
            id: this.props.reply.id,
            content: this.editField.getContent()
        };

        const mentions = utils.getMentions(updatedReply.content);
        this.editField.setProcessing(true);

        return this.props.commentsStore.checkMentionPermissionsAndAlert(mentions)
            .then(() => {
                return this.props.commentsStore.api.updateReply(
                    this.props.commentsStore.resource,
                    updatedReply,
                    mentions
                )
                    .then(res => {
                        const newComment = this.props.comment.toRaw();
                        newComment.replies.pop();
                        newComment.replies.push(res);
                        this.props.commentsStore.replaceComment(newComment);
                        this.exitEditing();
                    })
                    .catch(err => {
                        this.editField && this.editField.setProcessing(false);
                        toast('ERROR_OCCURED');
                    });
            });
    };

    renderCommentFieldActions = () =>
        (<span className='comment-actions'>
            <a
                className={`comment-action-btn ${this.editField.hasError() ? 'disabled' : ''}`}
                onMouseDown={ !this.editField.hasError() ? this.updateReply : null }
                ga-action={this.props.commentsStore.GASettings.action}
                ga-label='Finish_Edit_Reply'
            >{ gettext('Finish') }</a>
            <a
                className='comment-action-btn'
                onMouseDown={this.editField.clear}
                ga-action={this.props.commentsStore.GASettings.action}
                ga-label='Cancel_Edit_Reply'
            >{ gettext('Cancel') }</a>
        </span>);

    render () {
        return (<CommentField
            ref={editField => { this.editField = editField; }}
            placeholder={this.props.reply.content}
            onEnter={this.updateReply}
            onEscape={this.exitEditing}
            childrenFunc={this.renderCommentFieldActions}
            commentsStore={this.props.commentsStore}
        />);
    }
};

export default ReplyEdit;

ReplyEdit.propTypes = {
    reply: PropTypes.object,
    expandedComponent: PropTypes.object,
    comment: PropTypes.object,
    commentsStore: PropTypes.object.isRequired
};
